<template>
   <svg name="triangle-solid-exclamation" viewBox="0 0 20 20" aria-hidden="true" focusable="false">
      <path
         d="M2.275 17.5001H17.7167C18.3583 17.5001 18.7583 16.8085 18.4417 16.2501L10.7167 2.9168C10.3917 2.35846 9.59166 2.35846 9.275 2.9168L1.55 16.2501C1.23333 16.8085 1.63333 17.5001 2.275 17.5001ZM10.8333 15.0001H9.16666V13.3335H10.8333V15.0001ZM10 11.6668C9.54166 11.6668 9.16666 11.2918 9.16666 10.8335V9.1668C9.16666 8.70846 9.54166 8.33346 10 8.33346C10.4583 8.33346 10.8333 8.70846 10.8333 9.1668V10.8335C10.8333 11.2918 10.4583 11.6668 10 11.6668Z"
      />
   </svg>
</template>

<script setup lang="ts"></script>

<style lang="scss" scoped></style>
